import React from 'react';
import { Badge } from '../ui/badge';
import { MigracionEpisodiosFusion } from './MigracionEpisodiosFusion';
import { Kpis, Tabla, fechaAR } from './MigracionTabla';

const KPIS = [
  ['casos', 'Casos leídos'],
  ['casos_abiertos', 'Casos abiertos'],
  ['casos_cerrados_sin_tocar', 'Casos cerrados (no se tocan)'],
  ['casos_fusion_simulada', 'Casos duplicados (cuentan en su principal)'],
  ['casos_ya_absorbidos', 'Casos ya fusionados (se saltean)'],
  ['casos_a_migrar', 'Casos a migrar'],
  ['episodios_a_convertir', 'Episodios a convertir'],
  ['episodios_activos', 'Quedan ACTIVO'],
  ['episodios_vencidos', 'Quedan VENCIDO'],
  ['episodios_fusionados_a_escribir', 'Quedan FUSIONADO'],
  ['episodios_reincidentes', 'Marcados reincidencia'],
  ['contadores_que_cambian', 'Contadores de reincidencia que cambian'],
  ['em_pares', 'Movimientos a registrar'],
  ['em_ya_registrados', 'Ya registrados'],
  ['em_insertados', 'Registrados ahora'],
  ['documentos_modificados', 'Documentos modificados'],
];

const Movimientos = ({ r }) => (
  <div className="space-y-2" data-testid="migracion-episodios-movimientos">
    <p className="text-sm font-medium text-slate-700">Movimientos de las alertas (base actual y base histórica &lt; 2026)</p>
    {!r.historica_conectada && <p className="text-xs text-red-600">La base histórica no está conectada.</p>}
    <Kpis prefijo="migracion-mov" r={r} defs={[
      ['movimientos_buscados', 'IDs distintos en las alertas'], ['movimientos_base_actual', 'Encontrados en la base actual'],
      ['movimientos_base_historica', 'Encontrados en la base histórica'], ['movimientos_no_encontrados', 'No encontrados (quedan como están)'],
    ]} />
    <p className="text-xs text-slate-600" data-testid="migracion-episodios-rango">
      Fechas reales: del {fechaAR(r.fecha_primer_movimiento)} al {fechaAR(r.fecha_ultimo_movimiento)}
      {Object.keys(r.episodios_por_anio || {}).length > 0
        && ` · episodios que quedan, por año de inicio: ${Object.entries(r.episodios_por_anio).map(([a, n]) => `${a}: ${n}`).join(', ')}`}
    </p>
    {r.ids_no_encontrados?.length > 0 && (
      <p className="text-[11px] text-slate-500 font-mono break-all" data-testid="migracion-ids-no-encontrados">
        No encontrados: {r.ids_no_encontrados.join(', ')}
      </p>
    )}
  </div>
);

export const MigracionEpisodiosResultado = ({ r }) => (
  <div className="space-y-4" data-testid="migracion-episodios-resultado">
    <div className="flex items-center gap-2 text-sm">
      <Badge variant={r.modo === 'EJECUTAR' ? 'default' : 'secondary'}>{r.modo === 'EJECUTAR' ? 'Ejecutada' : 'Vista previa'}</Badge>
      <span className="text-slate-500">{new Date(r.inicio).toLocaleString('es-AR')}</span>
      {Object.keys(r.backups || {}).length > 0 && (
        <span className="text-xs text-emerald-700" data-testid="migracion-episodios-backups">Backup: {Object.keys(r.backups).join(', ')}</span>
      )}
    </div>
    {r.fusion_simulada && (
      <p className="text-xs text-amber-800 bg-amber-50 border border-amber-200 rounded p-2" data-testid="migracion-episodios-simulacion">
        Calculado como si los {Number(r.duplicados_pendientes).toLocaleString('es-AR')} casos duplicados ya estuvieran fusionados (paso 1 pendiente).
      </p>
    )}
    <Kpis defs={KPIS} r={r} prefijo="migracion" />
    {r.movimientos_buscados !== undefined && <Movimientos r={r} />}
    <MigracionEpisodiosFusion r={r} />
    <div>
      <p className="text-sm font-medium text-slate-700 mb-1">Configuración por monitor</p>
      <Tabla testid="migracion-episodios-monitores" rows={r.monitores || []} cols={[
        [(m) => m.nombre, 'Monitor'],
        [(m) => m.minimo_ocurrencias, 'Mín. movimientos'],
        [(m) => `${m.ventana_deteccion_dias} día(s)`, 'Ventana'],
        [(m) => `${m.dias_vencimiento} días`, 'Vence'],
        [(m) => (m.se_guarda?.length ? 'Se guarda' : 'Ya configurado'), 'Estado'],
      ]} />
    </div>
    {r.muestra_contadores?.length > 0 && (
      <div>
        <p className="text-sm font-medium text-slate-700 mb-1">Contadores de reincidencia que cambian (muestra)</p>
        <Tabla testid="migracion-episodios-contadores" rows={r.muestra_contadores} cols={[
          [(c) => c.titulo || c.caso_id, 'Caso'], [(c) => c.antes, 'Antes'], [(c) => c.despues, 'Después'],
        ]} />
      </div>
    )}
    {r.muestra_episodios?.length > 0 && (
      <div>
        <p className="text-sm font-medium text-slate-700 mb-1">Episodios (muestra)</p>
        <Tabla testid="migracion-episodios-muestra" rows={r.muestra_episodios} cols={[
          [(e) => e.titulo || e.caso_id, 'Caso'], [(e) => e.monitor, 'Monitor'], [(e) => e.estado, 'Estado'],
          [(e) => (e.es_reincidencia ? 'Sí' : 'No'), 'Reincidencia'], [(e) => fechaAR(e.ultimo_movimiento_nuevo), 'Último mov. nuevo'],
        ]} />
      </div>
    )}
  </div>
);
